import { render, staticRenderFns } from "./DeliveryDocument.vue?vue&type=template&id=57573b23&scoped=true&"
import script from "./DeliveryDocument.vue?vue&type=script&lang=js&"
export * from "./DeliveryDocument.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDocument.vue?vue&type=style&index=0&id=57573b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57573b23",
  null
  
)

export default component.exports